<template lang="pug">
  div(:style="rectStyle" :class="animationClassName").wrap-item-doodle-text
    span(:style="textStyle"
      v-html="htmlValue").doodle
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/doodleAnimation.scss";

.wrap-item-doodle-text {
  position: absolute;
  .doodle {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}
</style>

<script>

export default {
  props: {
    doodle: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      rectStyle: null,
      textStyle: null,
      htmlValue: ''
    }
  },
  computed: {
    animationClassName () {
      return this.doodle.animation ? `doodle-animation-${this.doodle.animation}` : ''
    }
  },
  created () {
    // this.rectStyle = `top: ${this.doodle.top}%; left: ${this.doodle.left}%;`
    //   + ` width: ${this.doodle.width}px; height: ${this.doodle.height}px;`

    this.rectStyle = `width: ${this.doodle.width}px; height: ${this.doodle.height}px;`

    const fontFamilyTmp = `'Noto Sans Japanese', Arial, Verdana, Roboto, "游ゴシック", "Yu Gothic", "游ゴシック体", "YuGothic", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "Meiryo UI", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif`
    const fo = this.doodle.fontOption
    this.textStyle =`color: ${fo.color}; font-size: ${fo.fontSize}px; font-weight: ${fo.fontWeight}; font-family: ${fo.fontFamily}, ${fontFamilyTmp};`
      + ` background: ${fo.backgroundColor};`
    this.htmlValue = this.doodle.value.replace(/\\n/g,'\n')
  }
}
</script>
